export default __webpack_public_path__ + "static/media/eju-lo2.f30a589f.svg";